// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: 'AIzaSyAc7_zCaKb7F5-8cL6GZLh7fomgXlWd9mw',
    authDomain: 'micro-bio-politics.firebaseapp.com',
    databaseURL: 'https://micro-bio-politics-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'micro-bio-politics',
    storageBucket: 'micro-bio-politics.appspot.com',
    messagingSenderId: '1065614693040',
    appId: '1:1065614693040:web:d39054370cb359dda16175',
    measurementId: 'G-1NEKZYGFQP',
};

// Initialize Firebase
const initialize = () => {
    return initializeApp(firebaseConfig);
};

export default initialize;
